"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePixel = void 0;
const assert_1 = require("../../../assert");
function validatePixel(value) {
    if (assert_1.assert.isString(value)) {
        const endsWithPx = value.endsWith('px');
        const integerToValidate = value.slice(0, value.length - 2);
        const containsOnlyNumbers = /^\d*$/.test(integerToValidate);
        return endsWithPx && containsOnlyNumbers && parseInt(integerToValidate, 10);
    }
    return false;
}
exports.validatePixel = validatePixel;
//# sourceMappingURL=unitValidations.js.map